(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-recently-viewed-section]';
  const observerRootMargin = '300px 0px';
  const CARD_VIEW_QUERY = '?view=card';

  const toInt = (value, fallback) => {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  };

  const safeParse = (value, fallback) => {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  };

  const getProductIdentity = (root) => {
    if (!root) return null;
    const handle = root.dataset.currentHandle || '';
    const id = root.dataset.currentId || '';
    if (!handle) return null;
    return { handle, id };
  };

  const isDebugEnabled = (root) => {
    if (!root) return false;
    return root.dataset.debug === 'true';
  };

  const debugLog = (root, ...args) => {
    if (!isDebugEnabled(root)) return;
    try {
      console.log('[RecentlyViewed]', ...args);
    } catch (error) {
      // Ignore console errors.
    }
  };

  const storageKeys = {
    list: 'sm_recently_viewed_products_v1',
    cachePrefix: 'sm_recently_viewed_card_'
  };

  const readList = () => {
    try {
      const raw = window.localStorage.getItem(storageKeys.list);
      const parsed = safeParse(raw, []);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const writeList = (items) => {
    try {
      window.localStorage.setItem(storageKeys.list, JSON.stringify(items));
    } catch (error) {
      // Intentionally ignore storage failures.
    }
  };

  const saveCurrentProduct = (root, storageLimit) => {
    const current = getProductIdentity(root);
    if (!current) return;

    const existing = readList();
    const deduped = existing.filter((item) => item && item.handle && item.handle !== current.handle);
    deduped.unshift({ handle: current.handle, id: current.id, ts: Date.now() });
    const finalList = deduped.slice(0, storageLimit);
    writeList(finalList);
    debugLog(root, 'track', current);
    debugLog(root, 'stored', finalList);
  };

  const getCache = (handle) => {
    try {
      return window.sessionStorage.getItem(`${storageKeys.cachePrefix}${handle}`) || '';
    } catch (error) {
      return '';
    }
  };

  const setCache = (handle, html) => {
    try {
      window.sessionStorage.setItem(`${storageKeys.cachePrefix}${handle}`, html);
    } catch (error) {
      // Intentionally ignore cache write failures.
    }
  };

  const fetchCardHtml = (root, handle) => {
    const cached = getCache(handle);
    if (cached) {
      debugLog(root, 'fetch cache hit', handle);
      return Promise.resolve(cached);
    }

    const url = `/products/${handle}${CARD_VIEW_QUERY}`;
    debugLog(root, 'fetch start', url);

    return fetch(url, { credentials: 'same-origin' })
      .then((response) => {
        debugLog(root, 'fetch response', url, response.status);
        if (!response.ok) throw new Error('Failed to fetch product card view');
        return response.text();
      })
      .then((html) => {
        setCache(handle, html);
        return html;
      })
      .catch(() => {
        debugLog(root, 'fetch failed', url);
        return '';
      });
  };

  const buildHandlesToRender = (root, limit) => {
    const current = getProductIdentity(root);
    const currentHandle = current ? current.handle : '';

    const handles = readList()
      .filter((item) => item && item.handle && item.handle !== currentHandle)
      .map((item) => item.handle)
      .filter((handle, index, arr) => arr.indexOf(handle) === index)
      .slice(0, limit);

    debugLog(root, 'render handles', handles);
    return handles;
  };

  const runThemeInitializers = (gridNode) => {
    if (!window.theme) return;

    window.requestAnimationFrame(() => {
      if (window.theme.ProductBlockManager && typeof window.theme.ProductBlockManager.loadImages === 'function') {
        window.theme.ProductBlockManager.loadImages(gridNode);
      }
      if (typeof window.theme.initAltThumbs === 'function') {
        window.theme.initAltThumbs(gridNode);
      }
      if (typeof window.theme.initAnimateOnScroll === 'function') {
        window.theme.initAnimateOnScroll();
      }

      const slider = gridNode && gridNode.closest ? gridNode.closest('carousel-slider') : null;
      if (slider && typeof slider.refresh === 'function') {
        slider.refresh();
      }
    });
  };

  const showRoot = (root) => {
    if (!root) return;
    root.classList.remove('recently-viewed-products-row--pending');
  };

  const hideRoot = (root) => {
    if (!root) return;
    root.hidden = true;
  };

  const isCarouselEnabled = (root) => root && root.dataset.enableCarousel === 'true';

  const buildGridMarkup = (root, responses) => {
    const cards = responses.filter((html) => html && html.trim());
    if (!cards.length) return '';

    if (!isCarouselEnabled(root)) {
      return cards.join('');
    }

    return cards.map((html) => `<div class="slider__item">${html}</div>`).join('');
  };

  const renderSection = (root) => {
    if (!root || root.dataset.recentlyViewedLoaded === 'true') return;

    const grid = root.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    root.dataset.recentlyViewedLoaded = 'true';
    const limit = toInt(root.dataset.limit, 6);
    const handles = buildHandlesToRender(root, limit);

    if (!handles.length) {
      hideRoot(root);
      return;
    }

    const gridCols = Math.max(1, toInt(root.dataset.grid, 4));
    root.style.setProperty('--rv-min-height', `${Math.max(240, 420)}px`);

    Promise.all(handles.map((handle) => fetchCardHtml(root, handle)))
      .then((responses) => {
        const markup = buildGridMarkup(root, responses);
        if (!markup.trim()) {
          hideRoot(root);
          debugLog(root, 'cards injected', false);
          return;
        }

        grid.innerHTML = markup;
        showRoot(root);
        debugLog(root, 'cards injected', true);

        const firstCard = grid.querySelector('.product-block');
        if (firstCard) {
          const cardHeight = Math.round(firstCard.getBoundingClientRect().height);
          if (cardHeight > 0) {
            const rows = Math.ceil(handles.length / gridCols);
            const reserved = Math.max(240, Math.min(cardHeight * rows, cardHeight * 2));
            root.style.setProperty('--rv-min-height', `${reserved}px`);
          }
        }

        runThemeInitializers(grid);
      })
      .catch(() => {
        hideRoot(root);
        debugLog(root, 'cards injected', false);
      });
  };

  const trackOnPageLoad = (root) => {
    if (!root || root.dataset.recentlyViewedTracked === 'true') return;
    root.dataset.recentlyViewedTracked = 'true';
    const storageLimit = toInt(root.dataset.storageLimit, 16);
    saveCurrentProduct(root, storageLimit);
  };

  const initRoot = (root) => {
    if (!root || root.dataset.recentlyViewedBound === 'true') return;
    root.dataset.recentlyViewedBound = 'true';

    trackOnPageLoad(root);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          renderSection(root);
        });
      }, { rootMargin: observerRootMargin });
      observer.observe(root);
      return;
    }

    renderSection(root);
  };

  const initAll = (scope = document) => {
    const roots = scope.querySelectorAll(rootSelector);
    roots.forEach((root) => initRoot(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event && event.target ? event.target : document;
    if (target.matches && target.matches(rootSelector)) {
      target.hidden = false;
      target.dataset.recentlyViewedLoaded = 'false';
      target.dataset.recentlyViewedBound = 'false';
      target.dataset.recentlyViewedTracked = 'false';
      target.classList.add('recently-viewed-products-row--pending');
      initRoot(target);
      return;
    }

    initAll(target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
